import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MLIcon from '../../../../../../components/MLIcon/MLIcon';
import styles from './WidgetContainer.module.css';
import { getConfigObject } from '../../../../../util/config';
import { getTestName } from '../../../../../util/util';

function WidgetContainer({ label, title, startCollapsed, clickOverride, enableAutoHeight = false, minWidthTitle = 520, children }) {
  const [isExpanded, setIsExpanded] = useState(!startCollapsed);

  const toggleExpanded = (event) => {
    if (clickOverride) {
      clickOverride(event);
    } else {
      setIsExpanded(!isExpanded);
    }
  };

  const handleKeyboardEvent = (event, func) => {
    if (event.key === 'Enter' || event.key === ' ') {
      func(event);
    }
  };

  const conditionallyRenderContent = () => {
    if (isExpanded) {
      return (
        <div
          className={styles.content}
          role="region"
          id={`panel-content-${label}`}
          aria-labelledby={`panel-header-${label}`}
        >
          {children}
        </div>
      );
    }
    return null;
  };

  const { FF_REPORTS_V2 } = getConfigObject();

  if (FF_REPORTS_V2) {
    return <div className={styles.content}>{children}</div>;
  }

  return (
    <div className={styles.widgetContainer}>
      <div
        id={`panel-header-${label}`}
        data-test-id={`panel_header_${getTestName(label)}`}
        className={`${styles.titleButton} ${enableAutoHeight ? '' : styles.limitHeight}`}
        role="button"
        onClick={toggleExpanded}
        onKeyDown={event => handleKeyboardEvent(event, toggleExpanded)}
        aria-expanded={isExpanded}
        aria-controls={`panel-content-${label}`}
        tabIndex={0}
        style={{ minWidth: minWidthTitle }}
      >
        <MLIcon
          className={styles.expandIcon}
          type={isExpanded ? 'chevron_down' : 'chevron_right'}
          role="presentation"
          width="15"
          height="15"
        />
        {title}
      </div>
      {conditionallyRenderContent()}
    </div>
  );
}

WidgetContainer.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.object.isRequired,
  startCollapsed: PropTypes.bool,
  clickOverride: PropTypes.func,
  enableAutoHeight: PropTypes.bool,
  minWidthTitle: PropTypes.number,
  children: PropTypes.object,
};

export default WidgetContainer;
